import { enableProdMode, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(AppModule),
    provideHttpClient(withFetch())
    // NOTE: provideClientHydration() intentionally removed. This app manipulates the DOM
    // heavily via jQuery / owl-carousel, which breaks Angular hydration and silently kills
    // client event handlers — dropdown (change), button (click). Without hydration, Angular
    // does a full client re-render after SSR, so every handler attaches reliably. SSR still
    // supplies the HTML for SEO. Trade-off: a brief re-render flash on first load.
  ]
}).catch(err => console.error(err));
